<div class="h-full w-full relative bg-surface-container-lowest">
    <mat-icon svgIcon="login_background"
        class="absolute w-full h-screen bg-repeat bg-surface-container-lowest pointer-events-none">
    </mat-icon>

    <div class="flex flex-col  items-center justify-center h-full relative z-10">
        <div class="flex-row  rounded-[5px] border-[1px] border-outline-variant h-[620px]">
            <div class="flex flex-col w-[360px] justify-between h-full rounded py-8 px-4 bg-surface-container-lowest">
                <div class="flex flex-col gap-y-4 items-center">
                    <mat-icon svgIcon="ic_sbox_brackets" class="h-[50px] w-[50px]"></mat-icon>
                    <div class="flex flex-col gap-y-2 items-center text-center justify-center">
                        <p class="mat-title-large text-on-surface ">Reset Password</p>
                        <p class=" mat-body-large text-on-surface-variant  ">
                            Provide the email address associated with your account and we’ll send you a link to reset
                            your password.
                        </p>
                        <form [formGroup]="forgotPasswordForm" (keyup.enter)="isValid()?verify():showError()"
                            class="w-full">
                            <mat-form-field appearance="outline" class="w-full mt-8">
                                <mat-label>Email</mat-label>
                                <input matInput placeholder="Email" formControlName="email" type="email">
                                <mat-error>
                                    <ng-container *ngIf="
                            forgotPasswordForm.controls['email'].errors &&
                            (forgotPasswordForm.controls['email'].dirty || forgotPasswordForm.controls['email'].touched)
                          ">
                                        <ng-container
                                            *ngFor="let error of forgotPasswordForm.controls['email'].errors | keyvalue">
                                            <ng-container *ngIf="error.key">
                                                <span>{{ error.value['message'] }}</span>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </mat-error>
                            </mat-form-field>

                        </form>
                    </div>


                </div>


                <div class="justify-center flex flex-col gap-y-4 ">
                    <ng-container *ngIf="!saveForm; else loading">
                        <button mat-flat-button class="w-full" (click)="isValid()?verify():showError()"
                            [id]="'sendResetPasswordEmailButton'">Send Reset
                            Link</button>
                    </ng-container>
                    <button mat-button class="w-full" (click)="navigateToLogin()" [id]="'navigateToLoginButton'">Return
                        to Log In</button>

                </div>
                <ng-template #loading>
                    <button mat-flat-button class="w-full" [id]="'buttondefaultButton'">
                        <canvas riv="cta-loading" width="28" height="28">
                            <riv-player name="loading-1" play></riv-player>
                        </canvas>
                    </button>
                </ng-template>

            </div>
        </div>
    </div>

</div>